export default __webpack_public_path__ + "af4c413193e1b90737121c4678757f09.svg";